module.exports = __webpack_public_path__ + "503a3a980ccbc651a8acc57b6f6d2dab.svg";